import styled from "styled-components";

export const QtyRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;

  .label {
    font-size: 18px;
    font-weight: 600;
  }
  .number {
    font-size: 19px;
    font-weight: 700;
  }

  input {
    width: 30%;
    max-width: 80px;
    height: 33px;
    border-radius: 5px;
    border: none;
    box-shadow: 0px 0px 2.5px 0px rgba(0, 0, 0, 0.67);
    font-size: 20px;
    font-weight: 600;
    text-align: right;
  }
`;
